import axios, { AxiosError, type AxiosResponse } from "axios";

import { store } from "../../redux/root";
import { refreshTokenCall } from "@/lib/redux/slices/auth.slice";

const iShipDocsApiInterceptor = axios.create({
	baseURL: import.meta.env.VITE_API_BASE_URL,
	timeout: 35000,
});

//  Request Interceptor
iShipDocsApiInterceptor.interceptors.request.use(
	(config: any) => {
		const token = store.getState().auth.token;

		config.headers = {
			...config.headers,
			Authorization: `Bearer ${token ?? ""}`,
			"Content-Type": "application/json",
		};

		return config;
	},
	(error) => Promise.reject(error)
);

//  Response Interceptor
iShipDocsApiInterceptor.interceptors.response.use(
	(response: AxiosResponse) => response,
	(error: AxiosError) => {
		if (error.response?.status === 401) {
			store.dispatch(refreshTokenCall());
		}

		if (!error.config?.url?.includes("/omt/api/logs")) {
			return Promise.reject(error);
		}

		return Promise.reject(error);
	}
);

export default iShipDocsApiInterceptor;
